var map = {
	"./download-data-by-freepik.png": "043e",
	"./email-by-freepik.png": "fbe6",
	"./icon_tick.png": "6c5a",
	"./icon_x.png": "33a6",
	"./no-data-by-anatoly.png": "4d82",
	"./no-data-by-freepik.png": "36d9",
	"./noise-by-freepik.png": "0d6f",
	"./upload-data-by-payungkead.png": "aafc",
	"./user-by-freepik.png": "ff95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";